export default __webpack_public_path__ + "static/media/aequalis26.b5d5066c.pdf";